import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../hooks/use-http";

import moment from "moment";

import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { useAuth } from "../../../store/auth";

const PhysicalInventoryForm = (props) => {
  const { warehouse } = useAuth();
  const [loading, setLoading] = useState(false);
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [subTypeData, setSubTypeData] = useState([]);
  const [filterdData, setFilterdData] = useState([]);
  const [subTypeId, setSubTypeId] = useState(0);
  const [typeData, setTypeData] = useState([]);
  const [typeId, setTypeId] = useState(0);

  const [warehouseId, setWarehouseId] = useState(0);

  const [productDetails, setProductDetails] = useState([]);

  const [physicalQuantity, setPhysicalQuantity] = useState(0);
  const [remark, setRemark] = useState("");

  const [data, setData] = useState([]);

  const { sendRequest: getEmp } = useHttp();
  const getAllEmp = () => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        var emplist = data.output; 

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    getAllEmp();
    console.log(warehouse);
  }, []);

  const { sendRequest: getItemType } = useHttp();

  useEffect(() => {
    getItemType(
      {
        url: `/api/fillProductTypesWithoutServices/`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setTypeData(res);
        }
      }
    );
  }, [getItemType]);

  const { sendRequest: getSubItem } = useHttp();

  useEffect(
    (e) => {
      const filterData =
        subTypeData &&
        subTypeData.filter(
          (item) => parseInt(item.productTypeId) === parseInt(typeId)
        );

      console.log(filterData);
      setFilterdData(filterData);
    },
    [typeId]
  );

  useEffect(() => {
    getSubItem(
      {
        url: `/api/productsubitem/`,
      },
      (res) => {
        if (res) {
          setSubTypeData(res);
        }
      }
    );
  }, [getSubItem]);
  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);

  const { sendRequest: getStockForClosing } = useHttp();

  const getData = () => {
    getStockForClosing(
      {
        url: `/api/stockForPhysicalInventory/?warehouseId=${warehouseId}&productTypeId=${typeId}&productSubTypeId=${subTypeId}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("api call", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    const newArray =
      data &&
      data.map((item) => ({
        stockId: item.stockId,
        productTypeNo: item.productTypeNo,
        productTypeName: item.productTypeName,
        productSubType: item.productSubType,
        productSubTypeName: item.productSubTypeName,
        productName: item.productName,
        itemId: item.itemId,
        unitAbbreviation: item.unitAbbreviation,
        unitName: item.unitName,
        conversionRation: item.conversionRation,
        productunitAbbreviation: item.productunitAbbreviation,

        totalUsedProductCost: item.usedTotalQuantity.totalUsedProductCost,
        totalUsedQuantity: item.usedTotalQuantity.totalUsedQuantity,
        batchNo: item.batchNo,
        productQuantity: item.productQuantity,
        quantity: item.productQuantityBal,
        itemUnitPrice: item.itemUnitPrice,
        productAmount: item.productAmount,
        productCost: item.productAmountBal,
        physicalQuantity: "",
        physicalProductCost: 0,
        unitId: item.unitId,
        remark: "",
        orgId: localStorage.getItem("orgId"),
      }));

    console.log(newArray);

    setProductDetails(newArray);
  }, [data]);

  useEffect(() => {
    getData();
  }, [warehouseId, typeId, subTypeId]);

  const { sendRequest: postPhysicalInventory } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    const input = {
      physicalInventoryDate: moment(currentDate).format("DD/MM/YYYY"),
      employeeId: employeeId,
      warehouseId: warehouseId,
      productDetails: productDetails,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      serviceId: props.sId,
    };

    console.log(input);

    postPhysicalInventory(
      {
        url: "/api/physicalInventory/",
        method: "POST",
        body: input,
      },
      (data) => {
        console.log(data);
        toast.success("Physical Inventory Added Successfully");

        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  const [itemsPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    productDetails && productDetails.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePhysicalQuantityChange = (stockId, value) => {
    const product = productDetails.find((item) => item.stockId === stockId);
    console.log(product);
    if (value > product.productQuantity) {
      toast.error(
        "Physical quantity should not be greater than product quantity"
      );
      return;
    }

    setPhysicalQuantity((prevPhysicalQuantity) => ({
      ...prevPhysicalQuantity,
      [stockId]: value,
    }));

    const updatedProductDetails = productDetails.map((item) => {
      //console.log(item.productQuantity);

      const physicalProductCost =
        (item.productAmount / item.productQuantity) * value;

      if (item.stockId === stockId) {
        return {
          ...item,
          physicalQuantity: parseInt(value),
          physicalProductCost: isNaN(physicalProductCost)
            ? 0
            : physicalProductCost,
        };
      }
      return item;
    });
    // console.log(updatedProductDetails);
    setProductDetails(updatedProductDetails);
  };

  const handleRemarkChange = (stockId, value) => {
    setRemark((prevRemark) => ({
      ...prevRemark,
      [stockId]: value,
    }));

    const updatedProductDetails = productDetails.map((item) => {
      if (item.stockId === stockId) {
        return {
          ...item,
          remark: value,
        };
      }
      return item;
    });
    //console.log(updatedProductDetails);
    setProductDetails(updatedProductDetails);
  };

  return (
    <>
      <div className="content-wrapper">
        <form onSubmit={submitHandler}>
          <section className="content">
            <div className="container-fluid">
              <div className="row mx-2">
                <div className="col-md-9">
                  <br />
                  <label className="">Physical Inventory</label>
                </div>
                <div className="col-md-3">
                  <br />
                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>{" "}
              </div>

              <div className="row mt-3 mx-3">
                <div className="col-md-3">
                  <div className="form-group">
                    {" "}
                    <label htmlFor={"date"}>{"Date"}</label>
                    <input
                      type={"date"}
                      id={"date"}
                      required
                      readOnly
                      className="form-control"
                      value={currentDate}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor={"executive_officer"}>
                    {"Assign Supervisor"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    required
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.empId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label htmlFor={"warehouse_name"}>
                    {"Warehouse Wise Stock"}
                  </label>

                  <select
                    id="warehouse_name"
                    className="form-control"
                    ref={(el) => (frmRef.current["warehouse_name"] = el)}
                    required
                    value={warehouseId}
                    onChange={(e) => {
                      setWarehouseId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {warehouse &&
                      warehouse.map((x) => (
                        <option key={x.id} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="row mx-3">
                <div className="col-md-3">
                  <label htmlFor={"product_type"}>{"Product Type"}</label>

                  <select
                    id="product_type"
                    className="form-control"
                    ref={(el) => (frmRef.current["product_type"] = el)}
                    required
                    value={typeId}
                    onChange={(e) => {
                      setTypeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {typeData &&
                      typeData.map((x) => (
                        <option
                          key={x.productItemTypeId}
                          value={x.productItemTypeId}
                        >
                          {x.productTypeName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label htmlFor={"product_subtype"}>{"Product SubType"}</label>

                  <select
                    id="product_subtype"
                    className="form-control"
                    ref={(el) => (frmRef.current["product_subtype"] = el)}
                    required
                    value={subTypeId}
                    onChange={(e) => {
                      setSubTypeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {filterdData &&
                      filterdData.map((x) => (
                        <option
                          key={x.productSubTypeId}
                          value={x.productSubTypeId}
                        >
                          {x.productSubTypeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <hr />
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body" style={{ padding: "1.4rem" }}>
                      <table className="table table-bordered table-responsive  text-center table-sm">
                        <thead>
                          <tr className="table-header">
                            <th> Item Id </th>
                            <th>Product Name</th>
                            <th> Batch No </th>

                            <th>Item Quantity </th>
                            <th>Amount</th>
                            <th>Unit</th>
                            <th>Item Quantity Balance </th>
                            <th>Amount</th>
                            <th>Used Quantity</th>
                            <th>Amount</th>
                            <th>Physical Quantity</th>
                            <th>Amount</th>
                            <th>Remark</th>
                          </tr>
                        </thead>

                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td> {itm.itemId} </td>

                                <td> {itm.productName} </td>

                                <td>{itm.batchNo}</td>
                                <td> {itm.productQuantity} </td>
                                <td>{itm.productAmount}</td>
                                <td> {itm.unitAbbreviation} </td>
                                <td>{itm.quantity}</td>
                                <td>{itm.productCost}</td>
                                <td>{itm.totalUsedQuantity}</td>
                                <td>{itm.totalUsedProductCost}</td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={itm.physicalQuantity}
                                    onChange={(e) =>
                                      handlePhysicalQuantityChange(
                                        itm.stockId,
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>{itm.physicalProductCost}</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={itm.remark}
                                    onChange={(e) =>
                                      handleRemarkChange(
                                        itm.stockId,
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>

                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="">
            <div className="text-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default PhysicalInventoryForm;
